import {createContext, useContext} from 'react';
import {OfficeContextType} from './types';

// Create Context
export const OfficeContext = createContext<OfficeContextType>({} as OfficeContextType);

// Encapsulated context hook
export const useOffice = () => useContext(OfficeContext);
